module.exports = __webpack_public_path__ + "static/media/photo165.7a1eeb92.jpg";